import { useMutation, useQueryClient } from '@tanstack/react-query';

import { financeExportReportApi, FINANCE_EXPORT_REPORTS } from '@entities/financeExportReport';

export const useDeleteFinanceExportReport = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (id: number) => financeExportReportApi.deleteReport(id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: FINANCE_EXPORT_REPORTS });
        },
    });
};
